<template>
    <div class="bidder-child-page">
        <div class="page-header">
            <div class="page-header-content">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title">二次报价</h2>
            </div>
            <div class="header-action">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>

        <!-- 内容区域 -->
        <div class="content-container">
            <template v-if="!offerConfigList || offerConfigList.length === 0">
                <div class="empty-content">
                    <p>代理未设置二次报价清单或未开始二次报价，请等待专家开启二次报价</p>
                </div>
            </template>
            <template v-else>
                <el-table :data="offerConfigList" border style="width: 100%;">
                    <el-table-column label="投标单位" prop="userName" />
                    <el-table-column label="报价时间" prop="offerTime" />
                    <el-table-column label="报价状态">
                        <template slot-scope="scope">
                            <span>{{ scope.row.isOffered === 1 ? '已报价' : '未报价' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="20">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.isOffered !== 1" type="primary" size="small"
                                @click="handleOffer(scope.row)">报价</el-button>
                            <el-button v-else type="primary" size="small" @click="handleOffer(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </div>
        <el-dialog title="报价" :visible.sync="offerDialogVisible" width="40%" :append-to-body="true">
            <div v-if="list && list.length" style="margin-bottom: 16px;">
                <el-table :data="list" border style="width: 100%;">
                    <el-table-column prop="itemName" label="条目名称" min-width="180" />
                    <el-table-column label="报价值" min-width="180">
                        <template slot-scope="scope">
                            <!-- 限制只能输入数字 -->
                            <el-input v-model="scope.row.itemValue" size="small" placeholder="请输入报价" type="number"
                                :disabled="currentOfferRow && currentOfferRow.isOffered === 1"  />
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="isUpload !== 0"
                style="margin-bottom: 20px; text-align: left;">
                <!-- 未报价：可上传/删除附件 -->
                <template v-if="!currentOfferRow || currentOfferRow.isOffered !== 1">
                    <el-button type="primary" size="small" @click="handleUploadAttachment">上传附件</el-button>
                    <span v-if="isUpload == 1" style="margin-left: 8px; font-size: 12px; color: #f56c6c;">（必填）</span>
                    <div v-if="attachmentFiles.length > 0" style="margin-top: 8px;">
                        <div v-for="(file, index) in attachmentFiles" :key="file.fileId" style="display: flex; align-items: center; margin-bottom: 4px;">
                            <span style="font-size: 12px; color: #666;">{{ file.fileName }}</span>
                            <el-button type="text" size="small" style="color: #f56c6c; margin-left: 8px;" @click="handleRemoveAttachment(index)">删除</el-button>
                        </div>
                    </div>
                </template>
                <!-- 已报价：只读展示附件 -->
                <template v-else-if="attachmentFiles.length > 0">
                    <span style="font-size: 12px; color: #666;">附件：</span>
                    <div v-for="file in attachmentFiles" :key="file.fileId" style="display: inline-block; margin-right: 8px; margin-top: 4px;">
                        <span style="font-size: 12px; color: #666;">{{ file.fileName }}</span>
                    </div>
                </template>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="offerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleConfirm" v-if="currentOfferRow.isOffered !== 1">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getOfferConfig, getOfferConfigList, saveOfferAgain } from '@/api/modules/offer'
import { doFileUpload } from '@/utils/upload/fileUploadHelper'
import { getBidderFlowTitle } from '@/utils/bid/projectInfo'
import { deleteBidAtt } from '@/api/modules/make'   
export default {
    name: 'BidSecondQuotate',
    data() {
        return {
            sectionCode: this.$route.query.sectionCode || '',   // 获取项目编号
            projectTitle: '',
            projectInfo: {
                sectionCode: this.$route.query.sectionCode
            },
            offerConfigList: [],
            offerDialogVisible: false,
            currentOfferRow: {
                isOffered: 1
            },
            list: [],
            isUpload: 0,
            fileBindId: '',
            attachmentFileId: '',
            attachmentFileName: '',
            attachmentFiles: []
        }
    },
    mounted() {
        this.fileBindId = Date.now().toString() + Math.floor(Math.random() * 100000)
        this.initPage()
        this.getProjectInfo()
    },
    methods: {
        // 获取项目信息
        async getProjectInfo() {
            this.projectTitle = await getBidderFlowTitle(this.sectionCode);
        },
        // 初始化页面
        initPage() {
            this.getOfferConfigList()
        },
        //获取报价配置
        getOfferConfigList() {
            getOfferConfigList(this.projectInfo.sectionCode).then(res => {
                if (res.code === 200) {
                    this.offerConfigList = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })

        },
        // 获取报价列表
        getOfferConfig() {
            getOfferConfig({ sectionCode: this.projectInfo.sectionCode, offerInfoId: this.currentOfferRow.id }).then(res => {
                if (res.code === 200) {
                    this.list = res.data.list || [];
                    this.isUpload = res.data.isUpload;
                } else {
                    this.offerList = []
                    this.$message.error(res.msg)
                }
            })

        },
        // 上传附件
        async handleUploadAttachment() {
            // 已报价状态下不允许上传附件
            if (this.currentOfferRow && this.currentOfferRow.isOffered === 1) {
                return
            }
            const input = document.createElement('input')
            input.type = 'file'
            input.multiple = true
            input.onchange = async (e) => {
                const files = Array.from(e.target.files)
                if (!files.length) return
                for (const file of files) {
                    file.fileType = 'second-quote-att'
                    try {
                        const uploadResult = await doFileUpload(file, {
                            fileBindId: this.fileBindId
                        })
                        if (uploadResult && uploadResult.success) {
                            this.attachmentFiles.push({
                                fileId: uploadResult.fileId || uploadResult.uploadFileId || '',
                                fileName: file.name
                            })
                            this.$message.success(`附件「${file.name}」上传成功`)
                        } else {
                            this.$message.error(uploadResult?.message || '附件上传失败')
                        }
                    } catch (error) {
                        this.$message.error(error.message || '附件上传失败')
                    }
                }
            }
            input.click()
        },
        // 删除附件
        handleRemoveAttachment(index) {
            deleteBidAtt(this.attachmentFiles[index].fileId).then(res => {
                if (res.code === 200) {
                    this.$message.success('删除成功')
                    this.attachmentFiles.splice(index, 1)
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 报价
        handleConfirm() {
            // isUpload == 1 必须上传附件
            if (this.isUpload == 1 && this.attachmentFiles.length === 0) {
                this.$message.error('必须上传附件')
                return
            }
            let data = {
                list: this.list,
                offerInfoId: this.currentOfferRow.id,
                sectionCode: this.projectInfo.sectionCode,
            }
            if (this.isUpload != 0 && this.attachmentFiles.length > 0) {
                data.fileBindId = this.fileBindId
            }
            saveOfferAgain(data).then(res => {
                if (res.code === 200) {
                    this.$message.success('报价成功')
                    this.offerDialogVisible = false
                    this.initPage()
                } else {
                    this.$message.error(res.msg)
                }
            })

        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        handleOffer(row) {
            this.currentOfferRow = row
            this.offerDialogVisible = true
            this.attachmentFiles = []
            console.log('--------执行', row);

            this.getOfferConfig()
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-child-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}

.page-header-content {
    display: flex;
    flex-direction: column;
    text-align: start;
}

.header-action {
    text-align: end;
    flex-shrink: 0;
}

.page-title {
    color: @gray-700;
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;
}

.content-container {
    padding: 20px;
    border-radius: 8px;
    box-shadow: @shadow-sm;
    background: #fff;
    text-align: start;
}

.empty-content {
    padding: 40px;
    text-align: center;
    color: @gray-500;
    background: @gray-50;
    border: 1px dashed @gray-300;
    border-radius: 8px;
}

/deep/ .el-dialog {
    border-radius: 8px;
}

/deep/ .el-dialog__header {
    background: @gray-50;
    border-bottom: 1px solid @gray-200;
}

/deep/ .el-dialog__title {
    color: @gray-700;
    font-weight: 600;
}

@media (max-width: 768px) {
    .bidder-child-page {
        padding: 16px;
    }

    .page-header {
        flex-direction: column;
        align-items: stretch;
    }

    .header-action {
        text-align: left;
    }

    .page-title {
        font-size: 20px;
    }

    .content-container {
        padding: 16px;
    }
}

.page-title {
    color: #333;
    margin: 0;
    font-weight: bold;
}

.content-wrap {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
}

.empty-content {
    display: flex;
    align-items: center;
    justify-content: center;
    color: black;
    font-size: 16px;
}
</style>